import { api } from './configs/axiosConfig';

const endPoint = "/leavecancellation";

export const leaveCancellationAPI = {
    getCancellableLeaves: async function (fromDate, toDate, pcode, empCode = null, showOnlyRequested = false) {
        const response = await api.request({
            url: endPoint,
            method: 'GET',
            params: { fromDate, toDate, pcode, empCode, showOnlyRequested }
        });

        return response.data;
    },
    submitLeaveCancellation: async function (selectedPcode, leaveId, cancellationReason, empCode) {
        const response = await api.request({
            url: `${endPoint}/cancel`,
            method: 'POST',
            data: { PCode: selectedPcode, LeaveId: leaveId, CancellationReason: cancellationReason, EmpCode: empCode }
        });

        return response.data;
    },
    getCancellationRequests: async function (fromDate, toDate, pcode) {
        const response = await api.request({
            url: `${endPoint}/cancellationrequests`,
            method: 'GET',
            params: { fromDate, toDate, pcode }
        });

        return response.data;
    },
    getAuthorizationLevels: async function (leaveId, pcode) {
        const response = await api.request({
            url: `${endPoint}/authorizationlevels/${leaveId}`,
            method: 'GET',
            params: { pcode }
        });

        return response.data;
    }
};
